import { AccountInfo } from 'pages/account/account-info';
import AuthRequired from 'pages/authentication/components/auth-required';

export default function AccountInfoRoute() {
  return (
    <AuthRequired>
      <AccountInfo />
    </AuthRequired>
  );
}
